module.exports = __webpack_public_path__ + "static/media/frameNew.624962bc.svg";